export const COPILOT_BASE_URL = "/copilot";
export const TRENDEX_BASE_URL = "/trendex";
export const SERVICE_LOG_BASE_URL = "/service-log";
export const SUPPORT_LINE_BASE_URL = "/support-line";
export const DASHBOARDS_BASE_URL = "/condition-monitoring";
export const ASSET_HEALTH_BASE_URL = "/asset-health";

export const FLEET_OVERVIEW_URL = `${DASHBOARDS_BASE_URL}/report/fleet-overview`;
